/**
 * StorageAdapter (Web)
 * Web-specific storage using localStorage
 */

/**
 * Unified storage interface
 */
export interface StorageInterface {
  getString: (key: string) => Promise<string | undefined>;
  setString: (key: string, value: string) => Promise<void>;
  delete: (key: string) => Promise<void>;
  getAllKeys: () => Promise<string[]>;
  clear: () => Promise<void>;
}

/**
 * LocalStorage adapter for web
 */
const LocalStorageAdapter: StorageInterface = {
  getString: async (key: string) => {
    try {
      const value = localStorage.getItem(key);
      return value || undefined;
    } catch (error) {
      console.error('localStorage.getItem error:', error);
      return undefined;
    }
  },
  setString: async (key: string, value: string) => {
    try {
      localStorage.setItem(key, value);
    } catch (error) {
      console.error('localStorage.setItem error:', error);
    }
  },
  delete: async (key: string) => {
    try {
      localStorage.removeItem(key);
    } catch (error) {
      console.error('localStorage.removeItem error:', error);
    }
  },
  getAllKeys: async () => {
    try {
      return Object.keys(localStorage);
    } catch (error) {
      console.error('localStorage.keys error:', error);
      return [];
    }
  },
  clear: async () => {
    try {
      localStorage.clear();
    } catch (error) {
      console.error('localStorage.clear error:', error);
    }
  },
};

/**
 * Get the storage adapter (always localStorage for web)
 */
export const getStorage = (): StorageInterface => {
  return LocalStorageAdapter;
};

/**
 * Export the storage instance
 */
export const storage: StorageInterface = getStorage();
